import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, map, switchMap, takeUntil } from 'rxjs/operators'

import {
  CHANGE_SEARCH_INPUT,
  CHANGE_WITHIN_LAST_DAYS,
  CREATE_IP_RANGE_ASYNC,
  DELETE_IP_RANGE_ASYNC,
  GET_IP_RANGE_LIST_ASYNC,
  UPDATE_IP_RANGE_ASYNC,
} from './constants'
import { selectIpModalData, selectIpRangeListData, selectIpRuleIdsToRemove } from './selectors'

const getIpRangeListEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(GET_IP_RANGE_LIST_ASYNC.INITIATE, CHANGE_SEARCH_INPUT, CHANGE_WITHIN_LAST_DAYS),
    switchMap(() =>
      api.settings
        .getIpRangeList(
          state$.value.partnerOptions.selectedCompany?.value,
          selectIpRangeListData(state$.value).search,
          selectIpRangeListData(state$.value).withinLastDays
        )
        .pipe(
          map((response) => GET_IP_RANGE_LIST_ASYNC.onSuccess({ data: response })),
          catchError((error) => of(epicsErrorHandler(GET_IP_RANGE_LIST_ASYNC.onError, error))),
          takeUntil(action$.pipe(ofType(GET_IP_RANGE_LIST_ASYNC.CANCEL)))
        )
    )
  )

const createIpRangeEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(CREATE_IP_RANGE_ASYNC.INITIATE),
    switchMap(() => {
      const ipDataModel = selectIpModalData(state$.value)

      return api.settings
        .createIpRange(state$.value.partnerOptions.selectedCompany?.value, {
          name: ipDataModel.name,
          rawValues: ipDataModel.rawValues,
          description: ipDataModel.description,
          applyForPastCampaigns: ipDataModel.isApplyForPastCampaigns,
        })
        .pipe(
          map((response) => CREATE_IP_RANGE_ASYNC.onSuccess({ data: response })),
          catchError((error) => of(epicsErrorHandler(CREATE_IP_RANGE_ASYNC.onError, error, [400]))),
          takeUntil(action$.pipe(ofType(CREATE_IP_RANGE_ASYNC.CANCEL)))
        )
    })
  )

const updateIpRangeEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(UPDATE_IP_RANGE_ASYNC.INITIATE),
    switchMap(() => {
      const apiData = selectIpModalData(state$.value)

      return api.settings
        .updateIpRange(state$.value.partnerOptions.selectedCompany?.value, apiData.id, {
          name: apiData.name,
          rawValues: apiData.rawValues,
          description: apiData.description,
        })
        .pipe(
          map((response) => UPDATE_IP_RANGE_ASYNC.onSuccess({ data: response })),
          catchError((error) => of(epicsErrorHandler(UPDATE_IP_RANGE_ASYNC.onError, error, [400]))),
          takeUntil(action$.pipe(ofType(UPDATE_IP_RANGE_ASYNC.CANCEL)))
        )
    })
  )

const deleteIpRangeEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(DELETE_IP_RANGE_ASYNC.INITIATE),
    switchMap(() => {
      const ids = selectIpRuleIdsToRemove(state$.value)

      return api.settings.deleteIpRange(state$.value.partnerOptions.selectedCompany?.value, ids)
    }),
    map((response) => DELETE_IP_RANGE_ASYNC.onSuccess({ data: response })),
    catchError((error) => of(epicsErrorHandler(DELETE_IP_RANGE_ASYNC.onError, error, [400]))),
    takeUntil(action$.pipe(ofType(DELETE_IP_RANGE_ASYNC.CANCEL)))
  )

export default combineEpics(
  getIpRangeListEpic,
  createIpRangeEpic,
  updateIpRangeEpic,
  deleteIpRangeEpic
)
